import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { ApiService } from '../services/api.service';

@Injectable({
  providedIn: 'root',
})
export class TokenInterceptService {
  constructor(private apiService: ApiService) {}
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // add authorization header with jwt token if available
    return from(this.handle(request, next));
    // const user = localStorage.getItem('user');
    // if (user) {
    //   request = request.clone({
    //     setHeaders: {
    //       Authorization: 'Bearer ' + user,
    //     },
    //   });
    // }
    // return next.handle(request);
  }
  async handle(req: HttpRequest<any>, next: HttpHandler) {
    const user = localStorage.getItem('user');
    console.log(req.url);
    if (req.url.startsWith('https://ipinfo.io/json?token=3eec16384fb130')) {
      return next.handle(req).toPromise();
    }
    let res;
    try {
      res = await this.apiService.getIp().toPromise();
    } catch (e) {
      res = {
        ip: '0.0.0.0',
      };
    }

    console.log('ip', res.ip);
    const headers = {};
    if (user) {
      headers['Authorization'] = 'Bearer ' + user;
    }
    if (res.ip) {
      headers['ClientIp'] = res.ip;
    }
    console.log(headers);
    req = req.clone({
      setHeaders: headers,
    });
    return next.handle(req).toPromise();
  }
}
